<div class="show-advert-statistics crm-scroll">
  <ng-container *ngTemplateOutlet="advertTemplate" />

  @if (loaders.statistics) {
    <ng-container *ngTemplateOutlet="skeletonTemplate" />
  } @else if (statistics?.statistics) {
    <ng-container *ngTemplateOutlet="statisticTemplate" />
  } @else {
    <ng-container *ngTemplateOutlet="errorTemplate" />
  }

  <ng-container *ngTemplateOutlet="olxInfoTemplate" />
</div>

<ng-template #advertTemplate>
  <div class="show-advert-statistics-advert">
    <div class="show-advert-statistics-advert-head">
      @if (advert.images?.[0]?.url) {
        <div class="show-advert-statistics-advert-avatar">
          <img [src]="$safeNavigationMigration(advert.images?.[0]?.url)" alt="advert image" />
        </div>
      }

      <div class="show-advert-statistics-advert-meta">
        <div class="show-advert-statistics-advert-status">
          {{ 'valid_to' | translate }}: {{ advert.valid_to | date: 'd MMM y, HH:mm' }}
        </div>

        <div class="show-advert-statistics-advert-title">
          {{ advert.title }}
        </div>

        <div class="show-advert-statistics-advert-price">
          {{ advert.price | olxPrice }}
        </div>
      </div>
    </div>

    @if (advert.statistics) {
      <div class="show-advert-statistics-advert-stats">
        @for (statKey of Object.keys(advert.statistics); track statKey) {
          <div class="show-advert-statistics-advert-stats-item">
            <app-icon class="icon-xxm">{{ ADVERT_STATISTICS_ICONS_MAP[statKey] }}</app-icon>
            <span>{{ advert.statistics[statKey] }}</span>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #statisticTemplate>
  <div class="show-advert-statistics-statistics">
    <app-advert-statistics-chart [statistics]="statistics?.statistics || []" />
  </div>
</ng-template>

<ng-template #skeletonTemplate>
  <div class="show-advert-statistics-statistics">
    <ngx-skeleton-loader class="skeleton-overlay" animation="progress" [theme]="{ width: '100%', height: '100%' }" />
  </div>
</ng-template>

<ng-template #errorTemplate>
  <div class="show-advert-statistics-statistics">
    <app-icon class="icon-150">sentiment_dissatisfied</app-icon>
    <span>{{ 'notifications_texts.error.failed_to_retrieve_advert_statistics' | translate }}</span>
  </div>
</ng-template>

<ng-template #olxInfoTemplate>
  <div class="show-advert-statistics-info" [innerHTML]="'olx_stat_info' | translate | safeHtml"></div>
</ng-template>
